"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pdfStore = void 0;
const api_1 = require("client/api");
const mobx_1 = require("mobx");
class PdfStore {
    constructor() {
        this.entirePDFPath = null;
        this.labelPDFPath = null;
        this.defaultPDFPath = '/defaultPDF.pdf';
        this.getClaimPDFs = async (claimId) => {
            const result = await api_1.ReportsEndpoint.getClaimPDFs.apiCall(null, { claimId });
            if (api_1.isError(result)) {
                console.log(result);
            }
            else {
                console.log(result);
                this.entirePDFPath = result.entirePDFSrc || null;
                this.labelPDFPath = result.labelsSrc || null;
            }
        };
    }
}
__decorate([
    mobx_1.observable
], PdfStore.prototype, "entirePDFPath", void 0);
__decorate([
    mobx_1.observable
], PdfStore.prototype, "labelPDFPath", void 0);
__decorate([
    mobx_1.action
], PdfStore.prototype, "getClaimPDFs", void 0);
exports.pdfStore = new PdfStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/pdf-ui/pdfStore.ts
// module id = 3859
// module chunks = 0